import { reducerRegistry } from '../../../../reducerRegistry';

import collectionsReducersMap from './collections/reducersMap';
import listsReducersMap from './lists/reducersMap';
import formsReducersMap from './forms/reducersMap';

const combineMap = {
  collections: collectionsReducersMap,
  lists: listsReducersMap,
  forms: formsReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('eventsModule', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/events/reducers/static/combineRegistry.js